// Color gradient options for choropleth maps.
// Colors drawn from the FCP brand palette.

export const GRADIENTS = [
  { id: 'green',  label: 'Green',  light: '#d4edba', dark: '#1a3a24' },
  { id: 'teal',   label: 'Teal',   light: '#cef3f8', dark: '#1e4d44' },
  { id: 'red',    label: 'Red',    light: '#fce8e0', dark: '#7a2035' },
  { id: 'purple', label: 'Purple', light: '#e0d4f8', dark: '#2e3a8c' },
  { id: 'blue',   label: 'Blue',   light: '#f0fbff', dark: '#467c9d' },
];

export function getGradient(id) {
  return GRADIENTS.find(g => g.id === id) ?? GRADIENTS[0];
}
